export class Const {
    public static DEFAULT_CULTURE = "en-US";
    public static IMG_AVATA_CHATBOT = "/icons/chatbot.png";
    public static DELIM_ROW = "`";
    public static DELIM_VALUE = "~";

    public static SYS_CHAT = "cht";
    public static SYS_WORKPLACE = "wp";
    public static SYS_TASK = "tk";


    public static USER_ID_BOT = 0;
    public static USER_ID_LOG = -2;
    public static USER_ID_KITISAK_LOCAL = 159;
    public static USER_ID_KITISAK_PRD = 77;
    public static CHATROOM_NO_ACTIVITY_DAY = 30;

    public static MAX_CLIPBOARD_IMAGE_FOR_SEND = 8;

    public static EMOJI_MEMBER_SPLITTER = '|';

    public static NON_WEB_USER_ID = -1;

    //public static NO_PERMISSION_ON_DCONNECT = "ยังไม่มีสิทธิ์ในการดูหัวข้อดังกล่าว\nเนื่องจากยังไม่ได้ผูกกับระบบ dconnect\nกรุณาติดต่อเซลล์";
    public static NO_PERMISSION_ON_DCONNECT = "ยังไม่มีสิทธิ์ในการดูหัวข้อดังกล่าว\nอาจเป็นเพราะยังไม่ผูกกับ ระบบภายใน หรือประเภทผู้ใช้ใน ระบบภายใน ไม่สอดคล้อง\nกรุณาติดต่อเซลล์";

    public static VERIFY_OTP_MSG = "REDIRECT_DASH";
    public static VERIFY_OTP_NEWCUS_WITH_INVITE = "NEWCUS_WITH_INVITE";
    public static VERIFY_OTP_NEWCUS_WITHOUT_INVITE = "VERIFY_OTP_NEWCUS_WITHOUT_INVITE";

    public static ERP_CUSTOMER_PAGE = "https://erp.2smetal.com/Sales/Reports/CustomerOnly/[CustomerId]/0?menu=0";

    public static MSG_LOG_ACTION_CHANGE_GROUP_NAME = "CHANGE_GROUP_NAME";


    public static UC_CHAT_ALIGH_RIGHT = "ChatAlignRight";
    public static UC_CHAT_ALIGH_RIGHT_ME = "Mine";
    public static UC_CHAT_ALIGH_RIGHT_COMP = "Company";
    public static UC_PUSH_FROM_CHAT = "PushFromChat";
    public static UC_PUSH_FROM_WP = "PushFromWp";
    public static MUST_SPECIFIC_INVITE_CODE_WHEN_REGISTER = false;


    // public static MAX_INLINE_WORKPLACE_IMG_WIDTH = "600px";
    // public static MAX_INLINE_WORKPLACE_IMG_HEIGHT = "150px";

    public static WP_CAT_EMP = "EMP";
    public static WP_CAT_EXU = "EXU";
    public static WP_CAT_EMP_FROM_BROWSE = "EMP.BROWSE";
    public static WP_CAT_CUS = "CUS";
    public static WP_CAT_SUP = "SUP";

    public static APP_DCONNECT = 1;
    public static APP_2SONLINE = 2;

    public static SEARCH_TAG_FROM_FILTER_PANE_FILTERPAN = 1;
    public static SEARCH_TAG_FROM_FILTER_PANE_DIALOG_TAG = 2;
    public static SEARCH_TAG_FROM_FILTER_PANE_FOR_EMBEDDED = 3;

    public static TEXT_NEW_WP_POST = "ตั้งโพสใหม่";
    public static TEXT_NEW_WP_TASK = "สร้างงานใหม่";

    public static TAG_UNREAD_NO_PENDING = -9;
    public static DAY_MONTH_END = 32;
    public static DAY_MONTH_END_NEXT = 33;

    public static WEEK_DAY_NO = [2, 3, 4, 5, 6, 7, 1];
    public static WEEK_DAY_NAME = ['จันทร์', 'อังคาร', 'พุธ', 'พฤหัส', 'ศุกร์', 'เสาร์', 'อาทิตย์'];

    public static LOAD_POST_TITLE_CALLING_FROM_DASH = "DASH";
}

export enum FrontEndApp {
    None = 0,
    AppChat2S = 1,
    AppSConnect = 2,
    AppDConnect = 3,
    App2SOnline = 4,
}

export enum TOOLS {
    TAG_WORK_PLACE_MANAGE = "TAG_WORK_PLACE_MANAGE",
    TAG_WORK_PLACE_FOLLOWER = "TAG_WORK_PLACE_FOLLOWER",
    QUICK_CHAT_REPLY = "QUICK_CHAT_REPLY",
    PERM_VISIBLE_CHAT_ICON = "PERM_VISIBLE_CHAT_ICON",
    PERM_VISIBLE_CHAT_ICON_SUP = "PERM_VISIBLE_CHAT_ICON_SUP",
    GROUP_CHAT_MEMBER = "GROUP_CHAT_MEMBER",
    SYNC_ERP_DATA = "SYNC_ERP_DATA",
    GENERAL_SETTING = "GENERAL_SETTING",
    NOTIFICATION_GLOBAL = "NOTIFICATION_GLOBAL",
    TASK_RECURANCE = "TASK_RECURANCE",
    EXTERNAL_USER = "EXTERNAL_USER",
    HOOK_MANAGER = "HOOK_MANAGER",
}

export enum PERMS {
    VISIBLE_CHAT_ICON = "VISIBLE_CHAT_ICON",
    VISIBLE_CHAT_ICON_SUPPLIER = "VISIBLE_CHAT_ICON_SUPPLIER"
}

// export enum CustomerApp {
//     Unknow = 0,
//     App_DConnect = 1, 
//     App_2SOnline = 2
// }

export enum QuickReplyContentTypes {
    None, Text, Sticker, Picture, File, Link
}

export enum SKeys {
    EmbActiveTab = "abb",
    EmbInitWpTag = "init_tag",
    EmbMemRoomId = "MemRoomId",
    EmbMemRoomAutoSel = "MemRoomIdAutoSelect",
    EmbInFrame = "EmbInFrame",

    InitWpFilterNoClose = "init_filterNotClose",
    InitTkFilterNoClose = "init_filterNotCloseTk",
    RedirectWpId = "redirectWpId",
    InitWpId = "init_wpid",
}

export enum RecuranceModes {
    None = "NN",
    Daily = "DL",
    Weekly = "WK",
    Monthly = "MN",
    Yearly = "YL",
    OneTime = "O1"
}

